import React from 'react';
import { Modal, Form, Input, Radio, message } from 'antd';
import { createEmptyFile } from '../../../../api/data-project-view';
import { addDoc } from '@/pages/documentCompile/api/data-project-doc';
import { DocumentFileType } from '@/pages/documentCompile/type';
import { getFileSuffixByType } from '@/pages/documentCompile/utils/file';
import { useSearchParams } from 'react-router-dom';

interface CreateFileModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  projectId: string;
  folderId?: number;
  viewId?: number;
  requestId?: number | string
}

const CreateFileModal: React.FC<CreateFileModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  projectId,
  folderId,
  requestId,
  viewId
}) => {
  const [form] = Form.useForm();
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const params = {
        docName: values.fileName + getFileSuffixByType(values.fileType),
        docType: values.fileType, // docx
        // fileType: values.fileType,
        folderId: folderId,
        projectId,
        viewId: viewId
      };
      await addDoc(params, requestId);
      message.success('新建空文件成功');
      form.resetFields();
      onSuccess();
    } catch (error) {
      message.error('新建空文件失败');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="新建文件"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={600}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item initialValue={DocumentFileType.WORD} label="文档类型" name="fileType">
          <Radio.Group>
            <Radio value={DocumentFileType.WORD}>Word</Radio>
            <Radio value={DocumentFileType.EXCEL}>Excel</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="文档名称"
          name="fileName"
          rules={[{ required: true, message: '请输入文档名称' }]}
        >
          <Input placeholder="请输入文档名称" onPressEnter={handleOk} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateFileModal; 
